import {
  GET_NOTIFICATIONS_FAILURE,
  GET_NOTIFICATIONS_REQUEST,
  GET_NOTIFICATIONS_SUCCESS,
} from "../actions/notificationAction";

const initialState = {
  notifications: [],
  loading: false,
  error: null,
  currentPage: 1,
  totalPages: 1,
  unreadCount: 0,

  next: null,
  previous: null,
};

export const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        notifications: action.payload.notifications,
        currentPage: action.payload.currentPage,
        totalPages: action.payload.totalPages,
        unreadCount: action.payload.unreadCount ?? state.unreadCount,
        next: action.payload.next,
        previous: action.payload.previous,
      };

    case GET_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};
